import { useMemo } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

function getTestIds(testIds: string[]): number[] {
    return testIds.reduce<number[]>((acc, testId) => {
        const numberTestId = Number(testId);

        if (Number.isInteger(numberTestId)) {
            acc.push(numberTestId);
        }

        return acc;
    }, []);
}

export const usePlayerTestIds = (): number[] => {
    const { testIds } = useFeatureFlags();

    return useMemo(() => getTestIds(testIds), [testIds]);
};
